/** Detect CommonJS. */
function isCjs() {
  return typeof require !== 'undefined';
}

export { isCjs };
//# sourceMappingURL=commonjs.js.map
